<div class="table-container" #tableContainer>
  <div style="height: 4px">
    @if (loading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
  <table
    #table
    mat-table
    [dataSource]="dataSource"
    matSort
    matSortStart="asc"
    (matSortChange)="onSortChange($event)"
    class="mat-elevation-z8 table-monitoring"
  >
    <ng-container sticky matColumnDef="mapa" class="column-table-monitoring">
      <th mat-header-cell *matHeaderCellDef>Mapa</th>
      <td mat-cell *matCellDef="let element; table: table">
        <button
          mat-icon-button
          type="button"
          aria-label="Visualizar mapa"
          [routerLink]="[
            '/monitoring-safras',
            'results',
            'monitored-area',
            element.areaId,
          ]"
          [queryParams]="getNavigationQueryParams(element)"
          (click)="onNavigateToDetails(element)"
        >
          <mat-icon>map</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="aviso">
      <th mat-header-cell *matHeaderCellDef>Aviso</th>
      <td mat-cell *matCellDef="let element; table: table">
        <mat-icon
          [class.has-value]="element.warning"
          [style.color]="element.warning ? '#4caf50' : 'inherit'"
          >{{ element.warning ? "circle" : "remove" }}</mat-icon
        >
      </td>
    </ng-container>

    <ng-container matColumnDef="alerta">
      <th mat-header-cell *matHeaderCellDef>Alerta</th>
      <td mat-cell *matCellDef="let element; table: table">
        <mat-icon
          [class.has-value]="element.alert"
          [style.color]="element.alert ? '#f44336' : 'inherit'"
          >{{ element.alert ? "warning" : "remove" }}</mat-icon
        >
      </td>
    </ng-container>

    <ng-container matColumnDef="area_monitorada">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="hectare-column"
        mat-sort-header
      >
        Área Monitorada<br />(ha)
      </th>
      <td
        mat-cell
        *matCellDef="let element; table: table"
        class="hectare-column"
      >
        {{ formatDecimal(element.monitoredAreaHa) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="area_cultura">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="hectare-column"
        mat-sort-header
      >
        Área Plantada {{ targetCulture ? `de ${targetCulture}` : "da Cultura"
        }}<br />(ha)
      </th>
      <td
        mat-cell
        *matCellDef="let element; table: table"
        class="hectare-column"
      >
        {{ formatDecimal(element.plantedCultureAreaHa) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="em_desenvolvimento">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="hectare-column"
        mat-sort-header
      >
        Em Desenvolvimento<br />(ha)
      </th>
      <td
        mat-cell
        *matCellDef="let element; table: table"
        class="hectare-column"
      >
        {{ formatDecimal(element.developingAreaHa) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="em_senescencia">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="hectare-column"
        mat-sort-header
      >
        Em Senescência<br />(ha)
      </th>
      <td
        mat-cell
        *matCellDef="let element; table: table"
        class="hectare-column"
      >
        {{ formatDecimal(element.senescenceAreaHa) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="apto_para_colheita">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="hectare-column"
        mat-sort-header
      >
        Apto para Colheita<br />(ha)
      </th>
      <td
        mat-cell
        *matCellDef="let element; table: table"
        class="hectare-column"
      >
        {{ formatDecimal(element.readyForHarvestAreaHa) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="area_colhida">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="hectare-column"
        mat-sort-header
      >
        Área Colhida<br />(ha)
      </th>
      <td
        mat-cell
        *matCellDef="let element; table: table"
        class="hectare-column"
      >
        {{ formatDecimal(element.harvestedAreaHa) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="cultura_divergente">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="hectare-column"
        mat-sort-header
      >
        Cultura Divergente<br />(ha)
      </th>
      <td
        mat-cell
        *matCellDef="let element; table: table"
        class="hectare-column"
      >
        {{ formatDecimal(element.divergentCultureAreaHa) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="nao_plantado">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="hectare-column"
        mat-sort-header
      >
        Não Plantado<br />(ha)
      </th>
      <td
        mat-cell
        *matCellDef="let element; table: table"
        class="hectare-column"
      >
        {{ formatDecimal(element.notPlantedAreaHa) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="possivel_cultura">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="hectare-column"
        mat-sort-header
      >
        Possível {{ targetCulture ?? "Cultura" }}<br />(ha)
      </th>
      <td
        mat-cell
        *matCellDef="let element; table: table"
        class="hectare-column"
      >
        {{ formatDecimal(element.possiblyTargetCultureAreaHa) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="aguardando_identificacao">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="hectare-column"
        mat-sort-header
      >
        Aguardando Identificação<br />(ha)
      </th>
      <td
        mat-cell
        *matCellDef="let element; table: table"
        class="hectare-column"
      >
        {{ formatDecimal(element.awaitingIdentificationAreaHa) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="zarc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Zarc</th>
      <td mat-cell *matCellDef="let element; table: table">
        @if (element.zarcRisk !== null) {
          <!-- Risco calculado e encontrado: 20 | 30 | 40 -->
          <span class="zarc-badge zarc-badge--{{ element.zarcRisk }}">
            {{ element.zarcRisk }}%
          </span>
        } @else if (element.zarcStatus === "not_found") {
          <!-- Cálculo executado, sem correspondência no ZARC -->
          <span
            class="zarc-badge zarc-badge--no-zoning"
            matTooltip="Cultura válida, mas não há zoneamento ZARC disponível para este município/ciclo/solo"
          >
            Fora do Zoneamento
          </span>
        } @else {
          <!-- Ainda não processado ou sem dados suficientes -->
          <span>—</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="idArea">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>ID Área</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.areaId ?? "—" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="nome_fazenda">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome Fazenda</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.farmName ?? "—" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="produtor">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Produtor</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.producer ?? "—" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="cpf_cnpj">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>CPF/CNPJ</th>
      <td mat-cell *matCellDef="let element; table: table">
        <!-- TODO: backend deve fornecer CPF/CNPJ individual da área -->
        {{ element.cpfCnpj ?? "—" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="uf">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>UF</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.state ?? "—" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="municipio">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Município</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.city ?? "—" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="car">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>CAR</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.car ?? "—" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="contrato">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Contrato</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.contract ?? "—" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="apolice">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Apólice</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.insurancePolicy ?? "—" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="cliente">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Cliente</th>
      <td mat-cell *matCellDef="let element; table: table">
        {{ element.organizationName }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.selected-row]="isSelectedRow(row)"
    ></tr>
  </table>

  @if (!loading && dataSource.data.length === 0) {
    <div class="empty-state">Nenhum resultado encontrado.</div>
  }
  <div style="height: 4px">
    @if (loading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
</div>
